import React, { useEffect, useState } from "react";
import { Grid, Divider, IconButton } from "@mui/material";
import { toast } from "react-toastify";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdAddBox } from "react-icons/md";
import { CiCircleQuestion } from "react-icons/ci";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { StyledTableCell, StyledTableRow } from "../MaterialTableStyle/MaterialTableStyle";
import CustomInput from "../CustomInputs/CustomInputs";
import CustomCheckBox from "../../Components/CheckBox/CustomCheckBox";
import CustomDropDown from "../../Components/DropDown/CustomDropDown";
import CustomModal from "../../Components/Modal/CustomModal";
import DatePicker from "../../Components/DateRangeSelector/DatePicker";
import { GradesInfo } from "./DataFile/Data";
import FileUploadButton from "../MaterialButtonStyle/UploadButton";
import { GreenColorButton, DarkGreenColorButton, PrimeGrayBorderColorButton, RedColorBorderButton } from "../../Components/MaterialButtonStyle/StyleButton";
import { S3Upload } from "../../Helper/api"
import { subjects } from "./DataFile/Data"
import { Mandatory } from "../../Utils/index"
const EducationalQualification = ({EducationsDetails,setEducationsDetails,setShowLoader,EducationQualificationsInfo,EducationLevel}) => {

  const [isDropdownOpen, setIsDropdownOpen] = useState(true);
  const ToggleDropdown = () => setIsDropdownOpen((prev) => !prev);
  const [educationalInfo, setEducationalInfo] = useState([]);
  const [subjectInfo, setSubjectInfo] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  useEffect(()=>{
    setSubjectInfo(subjects)
    setEducationalInfo(EducationsDetails)
  },[EducationsDetails])
  const HandleAttachmentValueChange = async(value, i) => {
    const files = value.target.files && value.target.files[0];
    if (files) {
      const maxFileSize = 5 * 1024 * 1024;
      if (files.size > maxFileSize) {
        toast.error("File size exceeds 5MB. Please upload a smaller file.");
        return;
      }
     
      try{
        setShowLoader(true);
        let today = Date.now()
        let Extention = String(files.name).split(".")
        let extension = Extention[Extention.length - 1]

        let name = "attachment/attachment" + today + "." + extension;
        let contenttype = "application/pdf";
        if (extension != "pdf") {
          contenttype = "image/png";
        }
        const data = await S3Upload({ name, file:value.target.files[0], contenttype });
        setShowLoader(false)
    
        const viewobj = [...educationalInfo];
        viewobj[i]["certificateAttachmentURL"] = data;
        setEducationsDetails(viewobj)
        setEducationalInfo(viewobj);
      }catch(Error){
        console.log("Error",Error)
        setShowLoader(false)
      }
     
    }
  }
  const HandleSaveOption = (index, row, type) => {
    if (type == "selectQualification") {
      const updatedOptions = educationalInfo.map((opt, i) =>
        i === index ? { ...opt, [type]: row?.value, qualificationLevel: row?.level } : opt
      );
      setSubjectInfo(row?.subjects);
      setEducationalInfo(updatedOptions);
      setEducationsDetails(updatedOptions)
    } else if(type == "qualificationLevel"){
      const updatedOptions = educationalInfo.map((opt, i) =>i === index ? { ...opt, [type]: row?.value } : opt);
      setSubjectInfo(row?.subjects);
      setEducationalInfo(updatedOptions);
      setEducationsDetails(updatedOptions)
    }else {
      const updatedOptions = educationalInfo.map((opt, i) => i === index ? { ...opt, [type]: row } : opt);
      setEducationalInfo(updatedOptions);
      setEducationsDetails(updatedOptions)
    }
  };
  const HandleSaveOption1 = (i, j, type, obj) => {
    const viewobj = [...educationalInfo];
    viewobj[i]["table"][j][type] = obj;
    setEducationalInfo(viewobj);
    setEducationsDetails(viewobj)
  }
  const HandleAddOption = () => {
    const nextId = educationalInfo.length > 0 ? educationalInfo[educationalInfo.length - 1].id + 1 : 1;
    const newOptionObj = {
      id: nextId, selectQualification: "",
      qualificationLevel: "",
      institutionName: "",
      courseName: "",
      startedOn: "",
      finishedOn: "",
      sittings: "",
      certificateNumber: "",
      certificateAttachmentURL: "",
      table:[{"Credit":"","Mandatory":"","subject":""}],
      subjectData: []
    };
    setEducationsDetails([...educationalInfo, newOptionObj])
    setEducationalInfo([...educationalInfo, newOptionObj]);
  };
  const HandleAddOption1 = (i) => {
    let newEducationalInfo = [...educationalInfo];
    if(i !=undefined){
      let newSubjectInfo = [...newEducationalInfo[i].table];
      newSubjectInfo.push({"Credit":"","Mandatory":"","subject":""})
      let updatedSubject = [...newSubjectInfo];
      newEducationalInfo[i].table = updatedSubject;
      setEducationalInfo(newEducationalInfo);
    }

  };
  const HandleOpenConfirmation = (i) => {
    setEditingIndex(i);
    setOpenModal(true);
  }
  const HandleDeleteOption = () => {
    const updatedOptions = educationalInfo.filter((_, i) => i !== editingIndex);
    setEducationalInfo(updatedOptions);
    setEducationsDetails(updatedOptions)
    setOpenModal(false);
  };

  const HandleDeleteOption1 = (i, j) => {
    let newEducationalInfo = [...educationalInfo];
    let newSubjectInfo = [...newEducationalInfo[i].table];
    newSubjectInfo = newSubjectInfo.filter((_, index) => index !== j);
    newEducationalInfo[i].table = newSubjectInfo;
    setEducationalInfo(newEducationalInfo);
    setEducationsDetails(newEducationalInfo)
  };

  return (
    <Grid container item lg={12} sm={12} md={12} xs={12}>
      <Grid container item lg={12} sm={12} md={12} xs={12} className="bg-white p-3 borderRadius10 mt-3" sx={{ boxShadow: "0px 0px 43.3px 0px #40BD6540" }}>
        <Grid item container lg={12} md={12} sm={12} alignItems={"center"} className="pointer" role="presentation" onClick={() => ToggleDropdown()}>
          <IconButton className="ButtonFoucusNone">
            {isDropdownOpen ? <IoIosArrowDropup color={"#000000"} size={"24px"} /> :
              <IoIosArrowDropdown color={"#000000"} size={"24px"} />}
          </IconButton>
          <h4 className="Text-Prime-Black poppinsMedium text-left pl-2">Educational Qualification</h4>
        </Grid>
        {isDropdownOpen ?
          <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} /> : ""}
        {isDropdownOpen && (<>
          <Grid item container lg={12} xs={12} className="mt-3 p-3" sx={{ backgroundColor: "#3B82F60A", borderRadius: "6px" }}>
            {educationalInfo?.length > 0 ?
              educationalInfo?.map((val, i) => (<>
                <Grid key={i} item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
                  <Grid item container lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"}>
                    <p className="text-black poppinsMedium pb-2 text-left">Select Qualification {Mandatory()}</p>
                    <CustomDropDown
                      isDisabled={i == 0 ? true : false}
                      backgroundColor={i == 0 ? "#EEECEC" : "#FFFFFF"}
                      placeholder={"Select your Qualification"}
                      data={EducationQualificationsInfo}
                      borderRadius={"8px"}
                      selected={
                        val?.selectQualification && {
                          label: val?.selectQualification,
                          value: val?.selectQualification,
                        }
                      }
                      onChange={(e) => HandleSaveOption(i, e, "selectQualification")}
                    />
                  </Grid>
                </Grid>
                <Grid item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
                  <Grid item container lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"}>
                    <p className="text-black poppinsMedium pb-2 text-left">Level{Mandatory()}</p>

                    <CustomDropDown
                      isDisabled={i == 0 ? true : false}
                      backgroundColor={i == 0 ? "#EEECEC" : "#FFFFFF"}
                      placeholder={"Select your Qualification"}
                      data={EducationLevel}
                      borderRadius={"8px"}
                      selected={
                        val?.qualificationLevel && {
                          label: val?.qualificationLevel,
                          value: val?.qualificationLevel,
                        }
                      }
                      onChange={(e) => HandleSaveOption(i, e, "qualificationLevel")}
                    />
                  </Grid>
                  <Grid item container lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"}>
                    <p className="text-black poppinsMedium pb-2 text-left">Course Name {Mandatory()}</p>
                    <CustomInput
                      backgroundColor="#FFFFFF"
                      width={"100%"}
                      height={"45px"}
                      placeholderColor={"#666666"}
                      padding={"2.5% 3% 2.5% 0%"}
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      placeholder="Enter Course Name"
                      maxLength={200}
                      value={educationalInfo[i]?.courseName}
                      onChange={(e) => HandleSaveOption(i, e.target.value, "courseName")}
                    />
                  </Grid>
                  <Grid item container lg={3.8} md={3.8} sm={12} xs={12}>
                    <p className="text-black poppinsMedium pb-2 text-left">School / Institution Name {Mandatory()}</p>
                    <CustomInput
                     
                      backgroundColor="#FFFFFF"
                      width={"100%"}
                      height={"45px"}
                      placeholderColor={"#666666"}
                      padding={"2.5% 3% 2.5% 0%"}
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      placeholder="Enter School / Institution Name"
                      maxLength={200}
                      value={educationalInfo[i]?.institutionName}
                      onChange={(e) => HandleSaveOption(i, e.target.value, "institutionName")}
                    />
                  </Grid>
                </Grid>
                <Grid item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
                  <Grid item container lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"}>
                    <p className="text-black poppinsMedium pb-2 text-left">Started On {Mandatory()}</p>
                    <DatePicker
                      isFuture={new Date()}
                      placeholder={"DD/MM/YYYY"}
                      height={"45px"}
                      fontFamily={"PoppinsMedium"}
                      backgroundColor="#FFFFFF"
                      border={"1px solid  #666666"}
                      Value={val?.startedOn}
                      handleInput={(e) => HandleSaveOption(i, e, "startedOn")}
                    />
                  </Grid>
                  <Grid item container lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"}>
                    <p className="text-black poppinsMedium pb-2 text-left">Finished On{Mandatory()}</p>
                    <DatePicker
                      placeholder={"DD/MM/YYYY"}
                      height={"45px"}
                      fontFamily={"PoppinsMedium"}
                      backgroundColor="#FFFFFF"
                      border={"1px solid  #666666"}
                      Value={val?.finishedOn}
                      handleInput={(e) => HandleSaveOption(i, e, "finishedOn")}
                    />
                  </Grid>
                  <Grid item container lg={3.8} md={3.8} sm={12} xs={12}>
                    <p className="text-black poppinsMedium pb-2 text-left">Select Options for How many Sittings? {Mandatory()}</p>
                    <Grid item container lg={12} flexWrap={"wrap"}>
                      <Grid item container lg={3} alignItems={"center"}>
                        <CustomCheckBox
                          disableColor={"#388e3c"}
                          checked={val?.sittings == "1 Sittings" ? true : false}
                          onChange={() => HandleSaveOption(i, "1 Sittings", "sittings")}
                        />
                        <p className="poppinsRegular Text-Prime-Gray text-left">1 Sittings</p>
                      </Grid>
                      <Grid item container lg={3} alignItems={"center"}>
                        <CustomCheckBox
                          disableColor={"#388e3c"}
                          checked={val?.sittings == "2 Sittings" ? true : false}
                          onChange={() => HandleSaveOption(i, "2 Sittings", "sittings")}
                        />
                        <p className="poppinsRegular Text-Prime-Gray text-left">2 Sittings</p>
                      </Grid>
                      <Grid item container lg={3} alignItems={"center"}>
                        <CustomCheckBox
                          disableColor={"#388e3c"}
                          checked={val?.sittings == "3 Sittings" ? true : false}
                          onChange={() => HandleSaveOption(i, "3 Sittings", "sittings")}
                        />
                        <p className="poppinsRegular Text-Prime-Gray text-left">3 Sittings</p>
                      </Grid>
                      <Grid item container lg={3} alignItems={"center"}>
                        <CustomCheckBox
                          disableColor={"#388e3c"}
                          checked={val?.sittings == "4 Sittings" ? true : false}
                          onChange={() => HandleSaveOption(i, "4 Sittings", "sittings")}
                        />
                        <p className="poppinsRegular Text-Prime-Gray text-left">4 Sittings</p>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
                  <Grid item container lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"}>
                    <p className="text-black poppinsMedium pb-2 text-left">Certificate Number {Mandatory()}</p>
                    <CustomInput
                      backgroundColor="#FFFFFF"
                      width={"100%"}
                      height={"45px"}
                      placeholderColor={"#666666"}
                      padding={"2.5% 3% 2.5% 0%"}
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      placeholder="Enter Certificate Number"
                      maxLength={200}
                      value={val?.certificateNumber}
                      onChange={(e) => HandleSaveOption(i, e.target.value, "certificateNumber")}
                    />
                  </Grid>
                  <Grid item container lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"}>
                    <p className="text-black poppinsMedium pb-2 text-left">Certificate Attachment {Mandatory()}</p>
                    <FileUploadButton
                      className="px-3 py-2 w-100"
                      placeholder={"Upload File"}
                      multiple={false}
                      accept="image/jpeg,image/png,application/pdf"
                      endIcon={true}
                      text={val?.certificateAttachmentURL}
                      onClick={(e) => HandleAttachmentValueChange(e, i, "certificateAttachmentURL")}
                    />
                  </Grid>
                  <Grid item container lg={3.8} md={3.8} sm={12} xs={12}></Grid>
                </Grid>
                <Grid
                  item
                  container
                  lg={12}
                  className="mt-3"
                >
                  <TableContainer>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell>Subject</StyledTableCell>
                          <StyledTableCell>Minimum Credit Expected</StyledTableCell>
                          {localStorage.getItem("@userType") == "superadmin" || localStorage.getItem("@userType") =="recruitadmin" ? <StyledTableCell align="center"></StyledTableCell> : ""}
                          <GreenColorButton className="px-2 py-2 mr-2" onClick={() => HandleAddOption1(i)} startIcon={<MdAddBox color={"#fff"} size={24} />}>Add New</GreenColorButton>
                        </StyledTableRow>
                      </TableHead>
                      <TableBody> 
                        {val?.table?.map((row, j) => {
                          return (
                            <StyledTableRow key={j}>
                              <StyledTableCell align="left">
                                <CustomDropDown
                                  placeholder={"Select your Subject"}
                                  data={subjectInfo}
                                  borderRadius={"8px"}
                                  backgroundColor="#FFFFFF"
                                  placement={"bottom"}
                                  selected={
                                    row?.defaultsubject && {
                                      label: row?.defaultsubject,
                                      value: row?.defaultsubject,
                                    }
                                  }
                                  onChange={(e) => HandleSaveOption1(i, j, "subject", e.value)}
                                />
                              </StyledTableCell>
                              <StyledTableCell>
                                <CustomDropDown
                                  placeholder={"Select your Minimum Credit Expected"}
                                  data={GradesInfo}
                                  borderRadius={"8px"}
                                  backgroundColor="#FFFFFF"
                                  placement={"bottom"}
                                  selected={
                                    row?.Credit && {
                                      label: row?.Credit,
                                      value: row?.Credit,
                                    }
                                  }
                                  onChange={(e) => HandleSaveOption1(i, j, "Credit", e.value)}
                                />
                              </StyledTableCell>
                              {localStorage.getItem("@userType") != "superadmin"?
                                <StyledTableCell align="center"><Grid item container lg={12} md={12} sm={12} justifyContent={"flex-end"} alignItems={"center"} className="mb-3">
                                  {educationalInfo[i]?.subjectInfo?.length - 1 == j ?
                                    <GreenColorButton className="px-2 py-2 mr-2" onClick={() => HandleAddOption1(i, j)} startIcon={<MdAddBox color={"#fff"} size={24} />}>Add New</GreenColorButton>
                                    : ""}
                                  {j >= 1 ?
                                    <RedColorBorderButton startIcon={<RiDeleteBin6Line color={"#E62A4A"} size={24} />} onClick={() => HandleDeleteOption1(i, j)}>{`Delete ${j + 1}`}</RedColorBorderButton>
                                    : ""}
                                </Grid></StyledTableCell>
                                : ""}
                            </StyledTableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
                {localStorage.getItem("@userType") != "superadmin" || localStorage.getItem("@userType") !="recruitadmin" ? (<>
                  <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
                  <Grid item container lg={12} md={12} sm={12} justifyContent={"flex-end"} alignItems={"center"} className="my-3">
                    {educationalInfo.length - 1 == i ?
                      <GreenColorButton className="px-2 py-2 mr-2" onClick={HandleAddOption} startIcon={<MdAddBox color={"#fff"} size={24} />}>Add New</GreenColorButton>
                      : ""}
                    {i >= 1 ?
                      <RedColorBorderButton startIcon={<RiDeleteBin6Line color={"#E62A4A"} size={24} />} onClick={() => HandleOpenConfirmation(i)}>{`Delete ${i + 1}`}</RedColorBorderButton>
                      : ""}
                  </Grid>
                </>) : ""}
              </>))
              :
              <Grid item container lg={12} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
                <h5 className="text-black poppinsMedium mt-3 mb-3">No fields Available</h5>
              </Grid>
            }
          </Grid>
        </>)
        }
      </Grid>
      <CustomModal
        open={openModal}
        setOpen={setOpenModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CiCircleQuestion color={"#12A59B"} size={100} />
          <p className="poppinsRegular Text-Prime-Black pt-3 text-center">Do you want to Delete this Educational Qualification?</p>
          <Grid item container display={"flex"} justifyContent={"center"} sx={{ marginTop: "6%" }}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => setOpenModal(false)}
            >
              No
            </PrimeGrayBorderColorButton>
            <DarkGreenColorButton
              type="submit"
              className="px-5 py-2 ml-2"
              onClick={() => HandleDeleteOption()}
            >
              Yes
            </DarkGreenColorButton>
          </Grid>
        </Grid>
        }
      />
    </Grid>
  )
}
export default EducationalQualification;